import React from 'react';
import Store from '../../_utils/tools/store';
import showLoginOverlay from '../utils/show-login-overlay';

const loginSection = () => {
  const handleLogin = () => {
    window.showLeaveOverlay = false;
    showLoginOverlay();
 }

  return (
    <div className="text-center">
      <i className="far fa-images large" />
      <h3 className="service-title font-weight-bold">My {Store.name} Photos</h3>
      <small className="d-block">Please log in to My {Store.name} Photos account</small>
      <button
        aria-label="Log in"
        className="btn btn-primary login font-weight-bold"
        onClick={handleLogin}
      >Log in
      </button>
      <small className="d-block more-space mb-2">If you do not have an account, please&nbsp;
        <a
          aria-label="Sign up"
          className="sign-up"
          href={window.urls.newAccount}
          role="link"
          tabIndex="0"
          title="Link to Create Account"
        >
          Sign Up.
        </a>
      </small>
    </div>
  );
}

export default loginSection;
